import { render, staticRenderFns } from "./Passwordset.vue?vue&type=template&id=74269c30&scoped=true"
import script from "./Passwordset.vue?vue&type=script&lang=js"
export * from "./Passwordset.vue?vue&type=script&lang=js"
import style0 from "./Passwordset.vue?vue&type=style&index=0&id=74269c30&prod&scoped=true&lang=css"
import style1 from "./Passwordset.vue?vue&type=style&index=1&id=74269c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74269c30",
  null
  
)

export default component.exports